import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { loadYouTubeAPI } from "./youtube";

// The index page's broadcast; the Working Man piece at / has its own track.
const YT_VIDEO_ID = "Kdn-TOF4z0I";
const TRACK_TITLE = "Lodi When";
const TRACK_ARTIST = "Zach Bryan";

const WORD = "joshdlee";

const LINES = [
  "whoami",
  'echo "nothing to see."',
  "ls ~/projects",
  "open --incognito",
  "status --quiet",
];

const pad = (n) => String(n).padStart(2, "0");
const fmt = (s) => {
  if (!Number.isFinite(s) || s < 0) s = 0;
  return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
};

const STYLES = `
  body.stealth-on, body.stealth-on html {
    margin: 0; padding: 0;
    background: #000;
    color: var(--ink-6);
    overflow: hidden;
    height: 100%;
    cursor: none;
  }
  .stealth-root {
    --bg: #000;
    --surface: #070707;
    --ridge: #111;
    --ink-0: #000;
    --ink-1: #0d0d0d;
    --ink-2: #1a1a1a;
    --ink-3: #2b2b2b;
    --ink-4: #4a4a4a;
    --ink-5: #7a7a7a;
    --ink-6: #b8b8b8;
    --ink-7: #e8e8e8;
    --accent: oklch(58% 0.04 245);
    --accent-dim: oklch(42% 0.035 245);
    --serif: "Newsreader", "Times New Roman", serif;
    --mono: "JetBrains Mono", ui-monospace, Menlo, monospace;
    font-family: var(--serif);
    color: var(--ink-6);
  }
  .stealth-root *, .stealth-root *::before, .stealth-root *::after { box-sizing: border-box; }

  .stealth-root .aura {
    position: fixed; inset: 0;
    pointer-events: none;
    background:
      radial-gradient(
        600px 600px at var(--mx, 50%) var(--my, 50%),
        color-mix(in oklab, var(--accent) 9%, transparent) 0%,
        transparent 60%
      );
    mix-blend-mode: screen;
    opacity: var(--glow, 0.55);
    transition: opacity .6s ease;
    z-index: 1;
  }

  .stealth-root .grid {
    position: fixed; inset: -10%;
    pointer-events: none;
    background-image:
      linear-gradient(to right, #0c0c0c 1px, transparent 1px),
      linear-gradient(to bottom, #0c0c0c 1px, transparent 1px);
    background-size: 64px 64px;
    transform: translate3d(var(--gx, 0), var(--gy, 0), 0);
    transition: transform .35s cubic-bezier(.2,.8,.2,1);
    opacity: .55;
    z-index: 0;
  }

  .stealth-root .chrome {
    position: fixed; top: 0; left: 0; right: 0;
    display: flex; justify-content: space-between; align-items: center;
    padding: 22px 28px;
    font-family: var(--mono);
    font-size: 11px;
    letter-spacing: .18em;
    text-transform: uppercase;
    color: var(--ink-4);
    z-index: 5;
  }
  .stealth-root .chrome .dot {
    display: inline-block; width: 6px; height: 6px;
    background: var(--accent-dim);
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
    box-shadow: 0 0 8px color-mix(in oklab, var(--accent) 40%, transparent);
  }
  .stealth-root .chrome .right { color: var(--ink-3); }
  .stealth-root .chrome .right span { color: var(--ink-5); }

  .stealth-root .hair {
    position: fixed;
    background: var(--ink-2);
    z-index: 4;
  }
  .stealth-root .hair.top { top: 56px; left: 28px; right: 28px; height: 1px; }
  .stealth-root .hair.bot { bottom: 56px; left: 28px; right: 28px; height: 1px; }

  .stealth-root .stage {
    position: relative;
    z-index: 3;
    height: 100vh;
    display: grid;
    place-items: center;
    padding: 0 24px;
  }
  .stealth-root .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 34px;
  }
  .stealth-root .kicker {
    font-family: var(--mono);
    font-size: 10.5px;
    letter-spacing: .42em;
    text-transform: uppercase;
    color: var(--ink-3);
    display: flex; align-items: center; gap: 14px;
  }
  .stealth-root .kicker i {
    display: inline-block;
    width: 38px; height: 1px;
    background: var(--ink-3);
  }

  .stealth-root .wordmark {
    font-family: var(--serif);
    font-weight: var(--wm-weight, 300);
    font-style: italic;
    font-size: clamp(88px, 18vw, 260px);
    line-height: .9;
    letter-spacing: -0.02em;
    color: var(--ink-2);
    user-select: none;
    display: flex;
    gap: 0;
    margin: 0;
  }
  .stealth-root .wordmark.not-italic { font-style: normal; }
  .stealth-root .wordmark .ch {
    display: inline-block;
    color: var(--c, var(--ink-2));
    text-shadow: var(--ts, none);
    transform: translateY(var(--ty, 0)) scale(var(--sc, 1));
    transition: color .2s ease, text-shadow .2s ease, transform .35s cubic-bezier(.2,.8,.2,1);
    will-change: color, transform, text-shadow;
  }

  .stealth-root .prompt {
    font-family: var(--mono);
    font-size: 12.5px;
    letter-spacing: .08em;
    color: var(--ink-5);
    display: flex; align-items: center; gap: 10px;
    opacity: 0; transform: translateY(6px);
    animation: stealth-rise .9s .4s forwards cubic-bezier(.2,.8,.2,1);
  }
  .stealth-root .prompt .p { color: var(--accent); }
  .stealth-root .prompt .typed { color: var(--ink-6); }
  .stealth-root .prompt .caret {
    display: inline-block;
    width: 7px; height: 14px;
    background: var(--ink-6);
    animation: stealth-blink 1.05s steps(2) infinite;
    transform: translateY(2px);
  }
  @keyframes stealth-blink { 0%,50% { opacity: 1 } 50.01%,100% { opacity: 0 } }
  @keyframes stealth-rise { to { opacity: 1; transform: translateY(0); } }

  .stealth-root .meta {
    position: fixed;
    bottom: 72px;
    left: 28px;
    z-index: 5;
    font-family: var(--mono);
    font-size: 10.5px;
    line-height: 1.8;
    letter-spacing: .12em;
    text-transform: uppercase;
    color: var(--ink-4);
    max-width: 260px;
  }
  .stealth-root .meta .k { color: var(--ink-3); }
  .stealth-root .meta .v { color: var(--ink-6); }
  .stealth-root .meta .row { display: flex; gap: 16px; }
  .stealth-root .meta .row .k { min-width: 78px; }

  .stealth-root .footer {
    position: fixed;
    bottom: 22px; left: 28px; right: 28px;
    z-index: 5;
    display: flex; justify-content: space-between; align-items: center;
    font-family: var(--mono);
    font-size: 10.5px;
    letter-spacing: .18em;
    text-transform: uppercase;
    color: var(--ink-3);
  }
  .stealth-root .footer .clock { color: var(--ink-5); }
  .stealth-root .footer .code { color: var(--ink-3); }

  .stealth-root .player {
    position: fixed;
    bottom: 72px;
    right: 28px;
    z-index: 6;
    width: 320px;
    background: linear-gradient(180deg, #080808 0%, #050505 100%);
    border: 1px solid var(--ink-2);
    border-radius: 2px;
    padding: 14px 16px 12px;
    font-family: var(--mono);
    color: var(--ink-6);
    box-shadow: 0 30px 80px rgba(0,0,0,.8), inset 0 1px 0 #121212;
    cursor: none;
  }
  .stealth-root .player .ph {
    display: flex; justify-content: space-between; align-items: center;
    font-size: 9.5px; letter-spacing: .3em; text-transform: uppercase;
    color: var(--ink-4);
    margin-bottom: 10px;
  }
  .stealth-root .player .ph .live { color: var(--accent); }
  .stealth-root .player .ph .live::before {
    content: ""; display: inline-block; width: 6px; height: 6px;
    background: var(--accent);
    border-radius: 50%;
    margin-right: 6px; transform: translateY(-1px);
    box-shadow: 0 0 8px color-mix(in oklab, var(--accent) 60%, transparent);
    animation: stealth-pulse 1.8s ease-in-out infinite;
  }
  @keyframes stealth-pulse { 50% { opacity: .35 } }

  .stealth-root .player .title {
    font-family: var(--serif); font-style: italic; font-weight: 300;
    font-size: 22px; color: var(--ink-7);
    line-height: 1.1; margin-bottom: 2px;
    letter-spacing: -0.01em;
  }
  .stealth-root .player .sub {
    font-size: 10px; letter-spacing: .2em; text-transform: uppercase;
    color: var(--ink-4); margin-bottom: 12px;
  }
  .stealth-root .player .scrub {
    height: 18px;
    position: relative;
    display: flex; align-items: center;
    cursor: none;
  }
  .stealth-root .player .scrub .track {
    flex: 1; height: 1px; background: var(--ink-2); position: relative;
  }
  .stealth-root .player .scrub .fill {
    position: absolute; inset: 0 auto 0 0; width: 0%;
    background: var(--ink-6);
  }
  .stealth-root .player .scrub .head {
    position: absolute; top: 50%; transform: translate(-50%, -50%);
    width: 8px; height: 8px; background: var(--ink-7);
    border-radius: 50%;
    left: 0%;
    box-shadow: 0 0 0 3px #000;
  }
  .stealth-root .player .bars {
    display: flex; align-items: flex-end; gap: 2px;
    height: 22px;
    margin-top: 10px;
  }
  .stealth-root .player .bars i {
    flex: 1; background: var(--ink-3); height: 20%;
    transition: height .15s ease, background .3s ease;
  }
  .stealth-root .player.is-playing .bars i { background: var(--ink-5); }
  .stealth-root .player .controls {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 10px;
    font-size: 10px; letter-spacing: .2em; text-transform: uppercase;
    color: var(--ink-4);
  }
  .stealth-root .player .ctrls { display: flex; gap: 14px; align-items: center; }
  .stealth-root .player button {
    background: none; border: none; color: var(--ink-6);
    font-family: var(--mono); font-size: 11px;
    letter-spacing: .14em; text-transform: uppercase;
    cursor: none; padding: 4px 0;
    border-bottom: 1px solid transparent;
    transition: color .2s, border-color .2s;
  }
  .stealth-root .player button:hover { color: var(--ink-7); border-color: var(--ink-3); }
  .stealth-root .player button.play { color: var(--accent); font-size: 10.5px; }
  .stealth-root .player a.watch {
    color: var(--ink-5); text-decoration: none;
    font-size: 10.5px; letter-spacing: .14em; text-transform: uppercase;
    cursor: none; padding: 4px 0;
    border-bottom: 1px solid transparent;
    transition: color .2s, border-color .2s;
  }
  .stealth-root .player a.watch:hover { color: var(--ink-7); border-color: var(--ink-3); }
  .stealth-root .player .time {
    font-variant-numeric: tabular-nums;
    color: var(--ink-5);
  }

  .stealth-root .gate {
    position: fixed; inset: 0;
    z-index: 40;
    background: #000;
    display: grid; place-items: center;
    padding: 0 24px;
    transition: opacity .9s ease, visibility 0s linear .9s;
  }
  .stealth-root .gate.out { opacity: 0; visibility: hidden; }
  .stealth-root .gate .inner {
    display: flex; flex-direction: column; align-items: center;
    gap: 28px;
  }
  .stealth-root .gate .mark {
    font-family: var(--serif); font-style: italic; font-weight: 300;
    font-size: clamp(40px, 7vw, 84px);
    letter-spacing: .12em;
    color: var(--ink-3);
    user-select: none;
  }
  .stealth-root .gate .cmd {
    font-family: var(--mono);
    font-size: 12.5px;
    letter-spacing: .08em;
    color: var(--ink-6);
    display: flex; align-items: center; gap: 10px;
  }
  .stealth-root .gate .cmd .p { color: var(--accent); }
  .stealth-root .gate .cmd .touch { display: none; }
  .stealth-root .gate .cmd .caret {
    display: inline-block;
    width: 7px; height: 14px;
    background: var(--ink-6);
    animation: stealth-blink 1.05s steps(2) infinite;
    transform: translateY(2px);
  }
  @media (hover: none) {
    .stealth-root .gate .cmd .key { display: none; }
    .stealth-root .gate .cmd .touch { display: inline; }
  }

  .stealth-root .yt-host {
    position: fixed; right: 0; bottom: 0;
    width: 200px; height: 200px;
    opacity: 0;
    pointer-events: none;
    z-index: -1;
  }
  .stealth-root .yt-host iframe { width: 100%; height: 100%; border: 0; }

  .stealth-root .cursor {
    position: fixed;
    z-index: 50;
    width: 14px; height: 14px;
    border: 1px solid var(--ink-6);
    border-radius: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);
    transition: width .2s, height .2s, background .2s, border-color .2s;
    mix-blend-mode: difference;
  }
  .stealth-root .cursor.dot {
    position: fixed; z-index: 51;
    width: 3px; height: 3px;
    background: var(--accent);
    border: none;
    border-radius: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 6px var(--accent);
    mix-blend-mode: normal;
  }

  .stealth-root .tweaks {
    position: fixed;
    bottom: 22px; right: 28px;
    z-index: 100;
    width: 280px;
    background: #060606;
    border: 1px solid var(--ink-2);
    padding: 14px 16px;
    font-family: var(--mono);
    color: var(--ink-6);
    font-size: 11px;
    letter-spacing: .04em;
    cursor: none;
  }
  .stealth-root .tweaks h3 {
    margin: 0 0 10px; font-size: 10px;
    letter-spacing: .3em; text-transform: uppercase; color: var(--ink-4);
    display: flex; justify-content: space-between; align-items: center;
  }
  .stealth-root .tweaks .row { display: flex; justify-content: space-between; align-items: center; margin: 9px 0; gap: 10px; }
  .stealth-root .tweaks label { color: var(--ink-5); font-size: 10.5px; }
  .stealth-root .tweaks input[type="range"] { flex: 1; accent-color: var(--accent); }
  .stealth-root .tweaks input[type="checkbox"] { accent-color: var(--accent); }
  .stealth-root .tweaks .val { color: var(--ink-7); min-width: 34px; text-align: right; font-variant-numeric: tabular-nums; }

  .stealth-root .wordmark .ch[data-dim="1"] { transition-duration: .8s; }

  @media (max-width: 640px) {
    .stealth-root .player { width: calc(100% - 56px); right: 28px; }
    .stealth-root .meta { display: none; }
    .stealth-root .tweaks { width: calc(100% - 56px); }
  }
`;

export default function StealthLanding() {
  const [tweaks, setTweaks] = useState({
    accentHue: 245,
    accentChroma: 0.075,
    wordmarkWeight: 550,
    glow: 0.55,
    showPrompt: true,
    showPlayer: true,
    italicWordmark: true,
    letterSpread: 0.18,
  });
  const [tweaksOpen, setTweaksOpen] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(`0:00 / 0:00`);
  const [clock, setClock] = useState("\u2014");
  const [issued, setIssued] = useState("\u2014");
  const [typed, setTyped] = useState("");
  const [ready, setReady] = useState(false);
  // Arriving from another page of the site, the visitor has already
  // interacted, so the song can start without the gate.
  const [entered, setEntered] = useState(
    () => !!(navigator.userActivation && navigator.userActivation.hasBeenActive)
  );
  const [sub, setSub] = useState("Loading\u2026");

  const tweaksRef = useRef(tweaks);
  useEffect(() => { tweaksRef.current = tweaks; }, [tweaks]);

  const rootRef = useRef(null);
  const wmRef = useRef(null);
  const auraRef = useRef(null);
  const gridRef = useRef(null);
  const curRef = useRef(null);
  const curDotRef = useRef(null);
  const fillRef = useRef(null);
  const headRef = useRef(null);
  const barsRef = useRef([]);
  const playerRef = useRef(null);
  const ytHostRef = useRef(null);
  const enteredRef = useRef(entered);
  const barsRAFRef = useRef(0);

  useEffect(() => {
    document.body.classList.add("stealth-on");
    return () => { document.body.classList.remove("stealth-on"); };
  }, []);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    root.style.setProperty("--accent", `oklch(58% ${tweaks.accentChroma} ${tweaks.accentHue})`);
    root.style.setProperty("--accent-dim", `oklch(42% ${tweaks.accentChroma * 0.9} ${tweaks.accentHue})`);
    root.style.setProperty("--wm-weight", String(tweaks.wordmarkWeight));
    root.style.setProperty("--glow", String(tweaks.glow));
  }, [tweaks.accentChroma, tweaks.accentHue, tweaks.wordmarkWeight, tweaks.glow]);

  useEffect(() => {
    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let tx = mx, ty = my;
    let raf = 0;
    const lerp = (a, b, t) => a + (b - a) * t;

    const onMove = (e) => { tx = e.clientX; ty = e.clientY; };
    const onLeave = () => { tx = window.innerWidth / 2; ty = window.innerHeight / 2; };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerleave", onLeave);

    const tick = () => {
      mx = lerp(mx, tx, 0.18);
      my = lerp(my, ty, 0.18);

      if (auraRef.current) {
        auraRef.current.style.setProperty("--mx", mx + "px");
        auraRef.current.style.setProperty("--my", my + "px");
      }
      if (gridRef.current) {
        const nx = (mx / window.innerWidth - 0.5);
        const ny = (my / window.innerHeight - 0.5);
        gridRef.current.style.setProperty("--gx", (-nx * 26) + "px");
        gridRef.current.style.setProperty("--gy", (-ny * 26) + "px");
      }
      if (curRef.current) { curRef.current.style.left = tx + "px"; curRef.current.style.top = ty + "px"; }
      if (curDotRef.current) { curDotRef.current.style.left = tx + "px"; curDotRef.current.style.top = ty + "px"; }

      const spread = tweaksRef.current.letterSpread;
      const glowT = tweaksRef.current.glow;
      const chars = wmRef.current ? wmRef.current.querySelectorAll(".ch") : [];
      for (const el of chars) {
        const r = el.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const dx = mx - cx, dy = my - cy;
        const d = Math.sqrt(dx * dx + dy * dy);
        const reach = 340;
        const t = Math.max(0, 1 - d / reach);
        const fromL = 0.10, toL = 0.92;
        const L = fromL + (toL - fromL) * t;
        el.style.setProperty("--c", `oklch(${L * 100}% 0 0)`);
        el.style.setProperty("--ty", `${-t * 14 * (spread * 2)}px`);
        el.style.setProperty("--sc", `${1 + t * 0.02}`);
        const g = t * glowT;
        el.style.setProperty("--ts",
          g > 0.05
            ? `0 0 ${16 * g}px color-mix(in oklab, var(--accent) ${g * 60}%, transparent), 0 0 ${48 * g}px color-mix(in oklab, var(--accent) ${g * 25}%, transparent)`
            : "none");
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerleave", onLeave);
    };
  }, []);

  useEffect(() => {
    let li = 0, ci = 0, deleting = false;
    let timer = null;
    let cancelled = false;
    const loop = () => {
      if (cancelled) return;
      if (!tweaksRef.current.showPrompt) {
        timer = setTimeout(loop, 200);
        return;
      }
      const cur = LINES[li];
      if (!deleting) {
        setTyped(cur.slice(0, ci++));
        if (ci > cur.length) {
          deleting = true;
          timer = setTimeout(loop, 1800);
          return;
        }
      } else {
        setTyped(cur.slice(0, ci--));
        if (ci < 0) { deleting = false; li = (li + 1) % LINES.length; }
      }
      timer = setTimeout(loop, deleting ? 28 : 70 + Math.random() * 60);
    };
    timer = setTimeout(loop, 1200);
    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, []);

  useEffect(() => {
    const tickClock = () => {
      const d = new Date();
      setClock(`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} LOCAL`);
    };
    tickClock();
    const id = setInterval(tickClock, 1000);
    setIssued(
      new Date()
        .toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" })
        .toUpperCase()
    );
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      const p = playerRef.current;
      if (!p || typeof p.getCurrentTime !== "function") return;
      const t = p.getCurrentTime() || 0;
      const dur = p.getDuration() || 0;
      const pct = dur > 0 ? (t / dur) * 100 : 0;
      if (fillRef.current) fillRef.current.style.width = pct + "%";
      if (headRef.current) headRef.current.style.left = pct + "%";
      setTime(`${fmt(t)} / ${fmt(dur)}`);
    }, 250);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let cancelled = false;
    let player = null;
    const host = ytHostRef.current;

    const start = () => {
      const p = playerRef.current;
      if (!p || typeof p.playVideo !== "function") return;
      p.unMute();
      p.setVolume(100);
      p.playVideo();
    };

    // Browsers block audio until the visitor interacts with the page, so the
    // gate's first click / tap / keypress is what starts the song.
    const GESTURES = ["pointerdown", "keydown", "touchend"];
    const onFirstGesture = () => {
      GESTURES.forEach((g) => window.removeEventListener(g, onFirstGesture, true));
      enteredRef.current = true;
      setEntered(true);
      start();
    };
    if (!enteredRef.current) GESTURES.forEach((g) => window.addEventListener(g, onFirstGesture, true));

    loadYouTubeAPI().then((YT) => {
      if (cancelled || !host) return;
      const el = document.createElement("div");
      host.appendChild(el);
      player = new YT.Player(el, {
        videoId: YT_VIDEO_ID,
        playerVars: {
          autoplay: 0,
          controls: 0,
          disablekb: 1,
          fs: 0,
          iv_load_policy: 3,
          playsinline: 1,
          rel: 0,
          origin: window.location.origin,
        },
        events: {
          onReady: (e) => {
            if (cancelled) return;
            playerRef.current = e.target;
            setReady(true);
            setSub(TRACK_ARTIST.toUpperCase());
            setTime(`0:00 / ${fmt(e.target.getDuration() || 0)}`);
            if (enteredRef.current) start();
          },
          onStateChange: (e) => {
            if (e.data === YT.PlayerState.PLAYING) { setPlaying(true); animateBars(); }
            if (e.data === YT.PlayerState.PAUSED) { setPlaying(false); stopBars(); }
            if (e.data === YT.PlayerState.ENDED) { e.target.seekTo(0); e.target.playVideo(); }
          },
          onError: (e) => {
            if (!cancelled) setSub("Unavailable");
            console.error("Stealth player: youtube error", e.data);
          },
        },
      });
    });

    return () => {
      cancelled = true;
      GESTURES.forEach((g) => window.removeEventListener(g, onFirstGesture, true));
      playerRef.current = null;
      if (player && typeof player.destroy === "function") player.destroy();
      if (host) host.innerHTML = "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key && e.key.toLowerCase() === "t") setTweaksOpen((v) => !v); };
    const onMsg = (e) => {
      const d = e.data || {};
      if (d.type === "__activate_edit_mode") setTweaksOpen(true);
      if (d.type === "__deactivate_edit_mode") setTweaksOpen(false);
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("message", onMsg);
    try { window.parent.postMessage({ type: "__edit_mode_available" }, "*"); } catch (e) {}
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("message", onMsg);
    };
  }, []);

  useEffect(() => {
    barsRef.current.forEach((el) => { if (el) el.style.height = "14%"; });
    return () => {
      if (barsRAFRef.current) cancelAnimationFrame(barsRAFRef.current);
    };
  }, []);

  function animateBars() {
    if (barsRAFRef.current) cancelAnimationFrame(barsRAFRef.current);
    let phase = 0;
    const els = barsRef.current.filter(Boolean);
    const loop = () => {
      phase += 0.06;
      els.forEach((el, i) => {
        const v = (Math.sin(phase + i * 0.35) * 0.5 + 0.5);
        const n = (Math.random() * 0.4);
        const h = Math.max(6, Math.min(100, (v * 60 + n * 30)));
        el.style.height = h + "%";
      });
      barsRAFRef.current = requestAnimationFrame(loop);
    };
    loop();
  }
  function stopBars() {
    if (barsRAFRef.current) cancelAnimationFrame(barsRAFRef.current);
    barsRef.current.forEach((el) => { if (el) el.style.height = "14%"; });
  }

  function handleTogglePlay() {
    const p = playerRef.current;
    if (!p) return;
    if (playing) {
      p.pauseVideo();
    } else {
      p.unMute();
      p.playVideo();
    }
  }

  const updateTweak = (k, v) => setTweaks((p) => ({ ...p, [k]: v }));

  return (
    <div className="stealth-root" ref={rootRef}>
      <style>{STYLES}</style>
      <div className="grid" ref={gridRef}></div>
      <div className="aura" ref={auraRef}></div>

      <header className="chrome">
        <div><span className="dot"></span>jdl &nbsp;/&nbsp; index</div>
        <div className="right">cold open &nbsp;&middot;&nbsp; <span>v0.4</span></div>
      </header>
      <div className="hair top"></div>

      <main className="stage">
        <div className="center">
          <div className="kicker"><i></i> A private practice <i></i></div>
          <h1
            className={`wordmark${tweaks.italicWordmark ? "" : " not-italic"}`}
            ref={wmRef}
            aria-label="joshdlee"
          >
            {[...WORD].map((ch, i) => (
              <span className="ch" key={i}>{ch}</span>
            ))}
          </h1>
          {tweaks.showPrompt && (
            <div className="prompt">
              <span className="p">~ $</span>
              <span className="typed">{typed}</span>
              <span className="caret"></span>
            </div>
          )}
        </div>
      </main>

      <aside className="meta" aria-hidden="true">
        <div className="row"><span className="k">File</span><span className="v">001</span></div>
        <div className="row"><span className="k">Issued</span><span className="v">{issued}</span></div>
      </aside>

      <div className="hair bot"></div>
      <footer className="footer">
        <div className="code">&nbsp;</div>
        <div className="clock">{clock}</div>
        <div className="code">© MMXXVI</div>
      </footer>

      {tweaks.showPlayer && (
        <section className={`player${playing ? " is-playing" : ""}`} aria-label="Ambient loop">
          <div className="ph">
            <span>Broadcast / 01</span>
            <span className="live">ON AIR</span>
          </div>
          <div className="title">{TRACK_TITLE}</div>
          <div className="sub">{sub}</div>
          <div className="scrub">
            <div className="track">
              <div className="fill" ref={fillRef}></div>
              <div className="head" ref={headRef}></div>
            </div>
          </div>
          <div className="bars">
            {Array.from({ length: 22 }).map((_, i) => (
              <i key={i} ref={(el) => { barsRef.current[i] = el; }}></i>
            ))}
          </div>
          <div className="controls">
            <div className="ctrls">
              <button className="play" onClick={handleTogglePlay} disabled={!ready}>
                {playing ? "\u25A0 Pause" : "\u25B6 Play"}
              </button>
              <Link className="watch" to="/">Watch &#8599;</Link>
            </div>
            <div className="time">{time}</div>
          </div>
        </section>
      )}

      {tweaksOpen && (
        <aside className="tweaks" aria-hidden="true">
          <h3>
            Tweaks <span onClick={() => setTweaksOpen(false)} style={{ cursor: "none" }}>×</span>
          </h3>
          <div className="row">
            <label>Accent hue</label>
            <input
              type="range" min="0" max="360" step="1"
              value={tweaks.accentHue}
              onChange={(e) => updateTweak("accentHue", Number(e.target.value))}
            />
            <span className="val">{tweaks.accentHue}</span>
          </div>
          <div className="row">
            <label>Accent chroma</label>
            <input
              type="range" min="0" max="0.15" step="0.005"
              value={tweaks.accentChroma}
              onChange={(e) => updateTweak("accentChroma", Number(e.target.value))}
            />
            <span className="val">{tweaks.accentChroma.toFixed(2)}</span>
          </div>
          <div className="row">
            <label>Wordmark weight</label>
            <input
              type="range" min="200" max="700" step="50"
              value={tweaks.wordmarkWeight}
              onChange={(e) => updateTweak("wordmarkWeight", Number(e.target.value))}
            />
            <span className="val">{tweaks.wordmarkWeight}</span>
          </div>
          <div className="row">
            <label>Glow</label>
            <input
              type="range" min="0" max="1" step="0.05"
              value={tweaks.glow}
              onChange={(e) => updateTweak("glow", Number(e.target.value))}
            />
            <span className="val">{tweaks.glow.toFixed(2)}</span>
          </div>
          <div className="row">
            <label>Letter lift</label>
            <input
              type="range" min="0" max="0.5" step="0.01"
              value={tweaks.letterSpread}
              onChange={(e) => updateTweak("letterSpread", Number(e.target.value))}
            />
            <span className="val">{tweaks.letterSpread.toFixed(2)}</span>
          </div>
          <div className="row">
            <label>Italic wordmark</label>
            <input
              type="checkbox"
              checked={tweaks.italicWordmark}
              onChange={(e) => updateTweak("italicWordmark", e.target.checked)}
            />
          </div>
          <div className="row">
            <label>Show prompt</label>
            <input
              type="checkbox"
              checked={tweaks.showPrompt}
              onChange={(e) => updateTweak("showPrompt", e.target.checked)}
            />
          </div>
          <div className="row">
            <label>Show player</label>
            <input
              type="checkbox"
              checked={tweaks.showPlayer}
              onChange={(e) => updateTweak("showPlayer", e.target.checked)}
            />
          </div>
        </aside>
      )}

      <div className="yt-host" ref={ytHostRef} aria-hidden="true"></div>

      <div className={`gate${entered ? " out" : ""}`} aria-hidden={entered}>
        <div className="inner">
          <div className="mark">joshdlee</div>
          <div className="cmd">
            <span className="p">~ $</span>
            <span><span className="key">press any key to enter</span><span className="touch">tap to enter</span></span>
            <span className="caret"></span>
          </div>
        </div>
      </div>

      <div className="cursor" ref={curRef}></div>
      <div className="cursor dot" ref={curDotRef}></div>
    </div>
  );
}
